import { isNullOrUndefined } from 'util';

export const highTemperatureThreshold: number = 37.3;
export const emptyId = "00000000-0000-0000-0000-000000000000";
export function getTemperatureStatus(temperature: number): string {
    return temperature === null ? "N/A" : temperature === 0 ? "UNMEASURED" : temperature > highTemperatureThreshold ? "HIGH TEMPERATURE" : "NORMAL";
}
export function getTemperatureStatusColor(temperature: number): string {
    return temperature === null ? "Black" : temperature === 0 ? "#35530a" : temperature > highTemperatureThreshold ? "Red" : "Green";
}

const apiValues = {
    inBio: "3.2.3",
    smartAC1: "Ver 2.0.30",
    speedFace: "Ver 2.0.36",
    speedFaceV5L: "Ver 2.0.32",
    version_2_4_1: "2.4.1", // ZKS1007 - speedface with fp v10
}

export function convertToPascalCase(text: string) {
    return text.replace(/(\w)(\w*)/g,
        (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase());
}

export function makeRandomId(length: number) {
    let result = '';
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charLength = chars.length;

    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() *
            charLength));
    }
    return result;
}

export function isSpeedface(value: string): boolean {
    return value.startsWith(apiValues.speedFace);
}

export function isSecurityPush(value: string): boolean {
    return value.startsWith(apiValues.speedFaceV5L) ||
        value.startsWith(apiValues.smartAC1) ||
        value.startsWith("3.0.1") ||
        value.startsWith("3.1.1") ||
        value.startsWith("3.1.2");
}

export function isInBio(value: string): boolean {
    return value.startsWith(apiValues.inBio);
}

export function isVersion_2_4_1(value: string): boolean {
    // Horus device
    // ZKS1007 - speedface with fp v10
    return value.startsWith("2.4.1");
}

export function objectToMap(value: object) {
    const map = new Map<string, string>();
    Object.keys(value).forEach(key => {
        map.set(key, (value as any)[key]);
    });
    return map;
}

export const handleNumeric = {
    onKeyDown(e: KeyboardEvent) {
        e = e || window.event; // Get event
        if (e.ctrlKey) {
            const c = e.which || e.keyCode; // Get key code
            switch (c) {
                case 86:  // Block Ctrl+V
                case 118: // Block Ctrl+v
                    // case 83: // Block Ctrl+S
                    // case 87: // Block Ctrl+W --Not work in Chrome
                    e.preventDefault();
                    e.stopPropagation();
                    break;
            }
        }
    },
    onKeyPress(e: KeyboardEvent | any, wholeNumberOnly: boolean = false) { // 
        const isNumber = !(e.key.length === 1 && isNaN(e.key) && !e.ctrlKey) && e.key !== ' ';
        if (!isNumber) {
            // if (plusSignPrefix && (e.key !== '+'))
            if (wholeNumberOnly ||
                e.key !== '.' ||
                (e.key === '.' && e.target.value.toString().indexOf('.') > -1)
            ) {
                e.preventDefault();
            }
        }
        // if (wholeNumberOnly) {
        //     if (e.key.length === 1 && isNaN(e.key) && !e.ctrlKey) {
        //         e.preventDefault();
        //     }
        // }
        // else {
        //     if (
        //         e.key.length === 1 && e.key !== '.' && isNaN(e.key) && !e.ctrlKey ||
        //         e.key === '.' && e.target.value.toString().indexOf('.') > -1 ||
        //         e.key === " "
        //     ) {
        //         e.preventDefault();
        //     }
        // }
    },
    onKeyPressPhoneDigits(e: KeyboardEvent | any) {
        // plusSign Prefix
        if (e.key === '+') {
            if (e.target.value.toString().indexOf('+') > -1 || (e.target.selectionStart > 0 && e.target.selectionStart > 0)) {
                e.preventDefault();
            }
        }
        else {
            handleNumeric.onKeyPressWholeNumber(e);
        }

    },
    onKeyPressWholeNumber(e: KeyboardEvent | any) {
        handleNumeric.onKeyPress(e, true);
    }
}


export function extractErrorMessages(errorMap: Map<string, string>) {
    const errorMessages = new Array<string>();
    errorMap.forEach((value, key) => {
        errorMessages.push(value);
    })
    return errorMessages;
}

export function isEmptyObjectId(objectId: string) {
    if (isNullOrWhitespaceString(objectId)) {
        return true;
    }
    return objectId === "0".repeat(24) || objectId === "0";
}

export function isNullOrWhitespaceString(text: string) {
    if (isNullOrUndefined(text)) {
        return true;
    }
    return text.replace(" ", "").length === 0;
}

export function getMapValues(map: Map<string, string>, uniqueOnly?: boolean) {
    const values = new Array<string>();
    map.forEach((value, key) => {
        if (!uniqueOnly) {
            values.push(value);
        }
        else if (values.findIndex(item => item === value) === -1) {
            values.push(value);
        }
    });
    return values;
}

export function checkDateRange(start: Date, end: Date, isRequiredStart: boolean = true, isRequiredEnd: boolean = true): string {
 
    const minDateAsDate  = new Date("1900-01-01");
    const maxDateAsDate = new Date("2999-12-31");
    if (isRequiredStart && isNullOrUndefined(start)) {
        return "Start date is required";
    }
    else if (isRequiredEnd && isNullOrUndefined(end)) {
        return "End date is required"
    }
    else if (isRequiredStart && isRequiredEnd) {
        if (start > end) {
            return "The start date must come before the end date";
        }
    }
    if (start < minDateAsDate) {
        return  "The start date is less than the allowable date input. "; 
    }
    if (end > maxDateAsDate) { 
        return "The end date is greater than the allowable date input."; 
    }
    return "";
}

export const minutesToTimeFormat = (minutes: number): string => {
    const totalHour = Math.floor(minutes / 60);
    const remainingMinute = (minutes % 60);

    return totalHour.toString().padStart(2, "0") + ":" + remainingMinute.toString().padStart(2, "0");
}
// export function checkDateRange(start: string, end: string) {
//     const minDateAsString = "1900-01-01";
//     const maxDateAsString = "2999-12-31";
//     const minDateAsDate = Date.parse(minDateAsString);
//     const maxDateAsDate = Date.parse(maxDateAsString);
//     const ret = {
//         Message: "Success",
//         Result: true,
//         Title: ""
//     };
//     var startDate = Date.parse(start);
//     var endDate = Date.parse(end);
//     if (isNaN(startDate) || startDate < 0) {
//         ret.Message = "Please enter a valid date. Previous valid start date is going to restore.";
//         ret.Result = false;
//         ret.Title = "Invalid"
//         return ret;
//     }
//     if (isNaN(endDate) || endDate < 0) {
//         ret.Message = "Please enter a valid date. Previous valid end date is going to restore.";
//         ret.Result = false;
//         ret.Title = "Invalid"
//         return ret;
//     }
//     var difference = (endDate - startDate) / (86400000 * 7);
//     if (difference < 0) {
//         ret.Message = "The start date must come before the end date. Previous valid date range is going to restore.";
//         ret.Result = false;
//         ret.Title = "Invalid"
//         return ret;
//     }
//     if (startDate < minDateAsDate) {
//         ret.Message = "The start date is less than the allowable date input. Previous valid date range is going to restore.";
//         ret.Result = false;
//         ret.Title = "Invalid"
//         return ret;
//     }
//     if (endDate > maxDateAsDate) {
//         //ret.Message = "The end date has exceeded the allowable date input. Previous valid date range is going to restore.";
//         ret.Message = "The end date is greater than the allowable date input. Previous valid date range is going to restore.";
//         ret.Result = false;
//         ret.Title = "Invalid"
//         return ret;
//     }
//     return ret;
// }
export function localStorageSetWithExpiry(key: string, value: string, ttl: number) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
        expiry: now.getTime() + ttl,
		value,
	}
	localStorage.setItem(key, JSON.stringify(item))
}
export function localStorageGetWithExpiry(key: string) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	// const now = new Date()
	// // compare the expiry time of the item with the current time
    // if (now.getTime() > item.expiry) {
    //     // If the item is expired, delete the item from storage
    //     // and return null
    //     localStorage.removeItem(key)
    //     return null
    // }
	return item.value
}
export function GetDeviceInfoValue(info: string, field: string){
    if(info === null){
        return "";
    }
    const arrItems = info.split(",");
    let result = "";
    arrItems.forEach((item)=> {

        const index = item.indexOf("=");

        let key = item;
        let val = "";

        if (index !== -1)
        {
            key = item.substring(0, index);
            val = item.substring(index + 1);
           if(key === field){
               result = val;
               return;
            } 
        } 
    }); 
    return result;
}


// WEBPACK FOOTER //
// ./src/utils/Utils.tsx